import type { IconSvgObject } from './types';

const SalahTimeIcon: IconSvgObject = [
  ["path", { d: "M8 16C4.6077 15.5133 2 12.5265 2 9C2 5.13401 5.13401 2 9 2C11.1524 2 13.1763 2.97153 14.5 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 7V9.61399L7.5 10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 15C12.5465 14.0053 12 13 12 12C12 9.42677 14.6667 9 16.4991 7C18.3315 9 21 9.42677 21 12C21 12.9947 20.4535 14.0053 20 15M13 15V22H16.5M13 15H11M13 15H20M20 15V22H16.5M20 15H22M16.5 22V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SalahTimeIcon;
